import { afterNextRender, inject, Injectable, Injector } from '@angular/core';

@Injectable()
export class FlipAnimationService {
  private readonly injector = inject(Injector);

  public flip(el: HTMLElement): void {
    const { top: beforeTop, height } = el.getBoundingClientRect();
    el.style.minHeight = `${height}px`;

    afterNextRender(
      () => {
        // Cancel any in-progress animation before measuring
        if (el.style.transform) {
          el.style.transition = 'none';
          el.style.transform = '';
        }

        const afterTop = el.getBoundingClientRect().top;
        const delta = beforeTop - afterTop;

        if (delta === 0) {
          el.style.minHeight = '';

          return;
        }

        el.style.transform = `translateY(${delta}px)`;

        requestAnimationFrame(() => {
          el.style.transition = 'transform 200ms ease-in-out';
          el.style.transform = 'translateY(0)';
          el.addEventListener(
            'transitionend',
            () => {
              el.style.transition = '';
              el.style.transform = '';
              el.style.minHeight = '';
            },
            { once: true },
          );
        });
      },
      { injector: this.injector },
    );
  }
}
